/**
 * PerformanceOptimizationPage - System performance monitoring
 *
 * Surfaces the PerformanceOptimizationDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides system performance monitoring with optimization recommendations.
 *
 * Route: /admin/performance-optimization
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconGauge } from '@tabler/icons-react';

import { PerformanceOptimizationDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function PerformanceOptimizationPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="yellow">
            <IconGauge size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Performance Optimization</Title>
            <Text size="sm" c="dimmed">
              System performance monitoring with AI-powered optimization recommendations
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <PerformanceOptimizationDashboard />
    </Container>
  );
}

export default PerformanceOptimizationPage;
